export default __webpack_public_path__ + "static/media/google-cloud.feb96ca8.svg";